import useResizeObserver from "@react-hook/resize-observer";
import { useRef, useState } from "react";
import styled from "styled-components";

const StyledLetterGroup = styled.div<{ $columns: number, $rows: number }>`
    display: flex;
    flex-direction: row;
    padding: 10px;
    position: relative;

    & + & {
        border-top: 1px solid #ccc;
    }

    & > i {
        position: absolute;
        visibility: hidden;
        top: -40px;
    }

    & > div:first-of-type {
        display: block;
        flex: none;
        font-family: "Nudista SemiBold", sans-serif;
        font-size: 4rem;
        text-transform: uppercase;
        width: 1em;

        span {
            position: sticky;
            top: 40px;
        }
    }

    & > div:last-of-type {
        display: grid;
        flex: auto;
        gap: 4px 10px;
        grid-auto-flow: column;
        grid-template-columns: repeat(${ ({ $columns }) => $columns }, minmax(0, 1fr));
        grid-template-rows: repeat(${ ({ $rows }) => $rows }, min-content);

        & > * {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
`;

function useColumnLayout(target, itemCount, size = 400) {
    const [width, setWidth] = useState(Number.MAX_SAFE_INTEGER);

    useResizeObserver(
        target,
        (entry) => setWidth(entry.contentRect.width),
    );

    const availableSpace = Math.min(window.innerWidth - 50, width);
    const $columns = Math.round(availableSpace / size);

    return {
        $columns,
        $rows: Math.ceil(itemCount / $columns),
    };
}

export default function LetterGroup(props) {
    const { letter, members, render } = props;

    const refColumns = useRef();
    const columnLayout = useColumnLayout(refColumns, members.length);

    if (members.length === 0) return null;

    return (
        <StyledLetterGroup
            { ...columnLayout }
            ref={ refColumns }
        >
            <i id={ letter } />
            <div>
                <span>{ letter }</span>
            </div>
            <div>
                {
                    members.map(render)
                }
            </div>
        </StyledLetterGroup>
    );
}
